/**
 * Created by trevor on 2015-03-19.
 */

function RelatedPosts() {
    this.extends = [_Helpers, _RSS, _ResponsiveLayout, _ContentLayout];
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this._imageRatio = 0.46206897;  // this value also in Search.js, FeaturedImage.js, _ResponsiveTitles.js

    this.init = function() {
        $(this.node).show();

        this.getRSS('/rss', $.proxy(this._onLoadRSS, this));
        this.registerResponsiveFunction($.proxy(this.resize, this, "mobile"), 0, window.mogo.registry.mogoUI.config.mediaQueries.small);
        this.registerResponsiveFunction($.proxy(this.resize, this, "tablet"), mogo.registry.mogoUI.config.mediaQueries.small + 1, mogo.registry.mogoUI.config.mediaQueries.medium);
        this.registerResponsiveFunction($.proxy(this.resize, this, "desktop"), mogo.registry.mogoUI.config.mediaQueries.medium + 1, null);
    };

    this.initAllReady = function() {};

    this._onLoadRSS = function() {
        var removeLoader = $.proxy(this.removeLoader, this);
        var categories = this.parseTags();
        var posts = this.lookupRSSbyCategories(categories, 3);

        this.setRelatedPostData(posts, function(){
            removeLoader();
        });
    }

    this.setRelatedPostData = function(posts, callback){
        var node = this;
        var postList = $(this.node).find('ul');

        if (posts.length > 0) {

            $(posts).each(function(){
                var title = $(this).find("title").text();
                var link = $(this).find("link").text();
                var postURI = node.parseURLtoURI(link);
                var post = node.lookupRSSbyURI(postURI);
                var img = node.getPostImage(post);

                postList.append('<li class="large-4 medium-12 small-12 columns"><div class="row"><a href="' + link + '"><div class="large-12 medium-6 small-6 columns"><div class="thumb" style="background-image:url('+ img +')"></div></div><div class="large-12 medium-6 small-6 columns text"><div class="contentContainer">' + title + '</div></div></a></div></li>');
            });

            var thumbs = $(".thumb", this.node);
            for (var i = 0; i < thumbs.length; i++) {
                $(thumbs[i]).mogo().create("FeaturedImage", {});
            }
        } else {
            postList.append('<li class="large-12 medium-12 small-12 columns"><br/>No related posts<br/><br/></li>');
        }
        callback();
    };

    this.parseTags = function(){
        var array = this.tags.split(",");
        this.trimArray(array, array.length - 1);

        return array;
    };

    this.resize = function(type) {
        this.layout_type = type;
        if (type == 'tablet' || type == 'mobile') {
            var title_width = $('.thumb', this.node).outerWidth();
            var title_height = (title_width * this._imageRatio) - $('.date', this.node).outerHeight();
            var texts = $('.text', this.node);
            for (var i = 0; i < texts.length; i++) {
                $(texts[i]).css('height', title_height);
                this.truncateText(texts[i]);
            }
        }
        if (type == 'desktop') {
            var texts = $('.text', this.node);
            //if (typeof $('.contentContainer', texts[0]).attr('title') == 'undefined') return;
            for (var i = 0; i < texts.length; i++) {
                var title = $('.contentContainer', texts[i]).attr('title');
                $('.contentContainer', texts[i]).text(title);
                $(texts[i]).css('height','auto');
            }
        }
    };

    this.reLayout = function(){
        if (this.layout_type !== null)
            this.resize(this.layout_type);
    };
}

